import http from '@/utils/http'

export function fetchArticle(params) {
	return http.get("/api/public/weixin/articles", {
		params: params
	});
}

export function selectArticle(id) {
	return http.get("/api/public/weixin/articles/" + id);
}